/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ScriptExecutionStateEnum = 'IN_PROGRESS' | 'SUCCESS' | 'FAILED';

export const ScriptExecutionStateEnum = {

    IN_PROGRESS: 'IN_PROGRESS' as ScriptExecutionStateEnum,

    SUCCESS: 'SUCCESS' as ScriptExecutionStateEnum,

    FAILED: 'FAILED' as ScriptExecutionStateEnum
};

